/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from '../actions/types';
// import { ROLES } from '../config';

const INITIAL_STATE = {
	termsAndConditions: []
};

export default function termsAndConditionsReducer(state = INITIAL_STATE, action) {
	// debugger; // eslint-disable-line no-debugger

	switch (action.type) {
		case types.GET_ALL_TERMS_AND_CONDITIONS:
			return { ...state, termsAndConditions: action.payload };
		default:
			return state;
	}
}

// Selectors
export const getTermsAndConditionsReducer = (state) => {
	return state.termsAndConditions.termsAndConditions;
}

